export { AuthHeading } from "./AuthHeading"
export type { AuthHeadingProps } from "./AuthHeading"
